import { render } from "./Adjustments.vue?vue&type=template&id=638b3b4e"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"

import "./Adjustments.vue?vue&type=style&index=0&id=638b3b4e&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__